<template>
    <Head :title="headTitle">
        <meta head-key="description" name="description" :content="resolvedDescription" />
        <meta head-key="og:site_name" property="og:site_name" :content="siteName" />
        <meta head-key="og:type" property="og:type" :content="ogType" />
        <meta head-key="og:title" property="og:title" :content="resolvedOgTitle" />
        <meta head-key="og:description" property="og:description" :content="resolvedDescription" />
        <meta head-key="og:url" property="og:url" :content="resolvedCanonical" />
        <meta head-key="og:locale" property="og:locale" :content="ogLocale" />
        <meta v-if="ogImage" head-key="og:image" property="og:image" :content="ogImage" />
        <meta head-key="twitter:card" name="twitter:card" :content="twitterCard" />
        <meta head-key="twitter:title" name="twitter:title" :content="resolvedOgTitle" />
        <meta head-key="twitter:description" name="twitter:description" :content="resolvedDescription" />
        <meta v-if="ogImage" head-key="twitter:image" name="twitter:image" :content="ogImage" />
        <meta v-if="noindex" head-key="robots" name="robots" content="noindex, nofollow" />
        <link head-key="canonical" rel="canonical" :href="resolvedCanonical" />
    </Head>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import { formatDocumentTitle, resolveMetaDescription, resolveOgTitle } from '@/utils/seo'

export default {
    components: {
        Head,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        canonical: {
            type: String,
            default: '',
        },
        home: {
            type: Boolean,
            default: false,
        },
        noindex: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        seo() {
            return this.$page?.props?.seo || {}
        },
        siteName() {
            return this.seo.name || 'ProfileSuite'
        },
        ogType() {
            return this.seo.og_type || 'website'
        },
        twitterCard() {
            return this.seo.twitter_card || 'summary_large_image'
        },
        ogImage() {
            return this.seo.og_image || ''
        },
        ogLocale() {
            const locale = this.$page?.props?.locale || 'en'
            return locale.replace('_', '-')
        },
        headTitle() {
            if (this.home) {
                return null
            }

            const normalized = (this.title || '').trim()
            if (!normalized || normalized === 'Home' || normalized === 'Card Information') {
                return null
            }

            return normalized
        },
        resolvedDescription() {
            return resolveMetaDescription(this.description, this.seo)
        },
        resolvedOgTitle() {
            if (this.home) {
                return formatDocumentTitle(null, this.seo)
            }

            return resolveOgTitle(this.title, this.seo)
        },
        resolvedCanonical() {
            if (this.canonical) {
                return this.canonical
            }

            if (typeof window !== 'undefined') {
                return window.location.href.split('#')[0]
            }

            return ''
        },
    },
}
</script>
